import {
  BarChart3,
  Bot,
  BookOpen,
  Languages,
  ShieldCheck,
  TicketCheck,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";
import SectionHeading from "./SectionHeading";

interface Feature {
  icon: LucideIcon;
  title: string;
  body: string;
}

const FEATURES: Feature[] = [
  { icon: Bot, title: "AI Travel Assistant", body: "Get personalized itineraries and real-time help." },
  { icon: BookOpen, title: "Heritage Storytelling", body: "Dive deep into stories, legends and history." },
  { icon: BarChart3, title: "Personalized Trips", body: "Trips planned as per your interests and budget." },
  { icon: Languages, title: "Multi-Language Support", body: "Explore in your language, anytime, anywhere." },
  { icon: ShieldCheck, title: "Verified & Trusted", body: "Verified guides, stays and authentic information." },
  { icon: TicketCheck, title: "Smart Heritage Pass", body: "Digital pass for seamless entry, tickets and experiences." },
];

export default function WhyChoose() {
  return (
    <section id="about" className="bg-white py-20">
      <div className="container-page">
        <SectionHeading title="Why Choose Maayad?" />
        <div className="mt-12 grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-6">
          {FEATURES.map((f) => {
            const Icon = f.icon;
            return (
              <article key={f.title} className="text-center">
                <span className="mx-auto mb-3 grid h-14 w-14 place-items-center rounded-full bg-iris-50 text-iris-500 transition hover:bg-iris-500 hover:text-white">
                  <Icon size={24} strokeWidth={1.7} />
                </span>
                <h3 className="font-display text-sm font-semibold text-navy-900">
                  {f.title}
                </h3>
                <p className="mt-1 text-xs leading-relaxed text-slate-500">{f.body}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
